import Vuex from "vuex"
import Vue from 'vue'
import os from './os'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    os: os
  }
})


// WEBPACK FOOTER //
// ./src/store/index.js